import {Balance} from './balance.model';
import {BalancePayment} from './balance-payment.model';
import {BalanceExpense} from './balance-expense.model';

/**
 * Złożony obiekt odpowiedzi (Response DTO), zawierający pełny obraz finansów użytkownika w danej klinice.
 * Służy do jednorazowego załadowania wszystkich potrzebnych danych.
 */
export class CurrentBalanceResponse {

  public balance: Balance;
  public balancePayments: BalancePayment[];
  public balanceExpenses: BalanceExpense[];

  constructor() {
  }
}

